import { SVGProps } from 'react'

export const StageVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={81}
    fill="none"
    {...props}
  >
    <g filter="url(#a)">
      <path
        fill="#fff"
        d="M33.282 8.661a5.6 5.6 0 0 1 5.665 0L61.06 21.627a5.6 5.6 0 0 1 2.767 4.831v26.084a5.6 5.6 0 0 1-2.767 4.83L38.947 70.34a5.6 5.6 0 0 1-5.665 0L11.169 57.373A5.6 5.6 0 0 1 8.4 52.542V26.458a5.6 5.6 0 0 1 2.768-4.83L33.282 8.66Z"
      />
      <path
        fill="#6C1B1B"
        d="M33.304 15.62a5.6 5.6 0 0 1 5.62 0l16.69 9.68a5.6 5.6 0 0 1 2.791 4.845v19.409a5.6 5.6 0 0 1-2.79 4.844l-16.69 9.682a5.6 5.6 0 0 1-5.62 0l-16.691-9.682a5.6 5.6 0 0 1-2.79-4.844v-19.41a5.6 5.6 0 0 1 2.79-4.843l16.69-9.682Z"
      />
      <circle cx={36.114} cy={40} r={17} fill="#E24137" />
      <path
        fill="#EFF3EE"
        d="M30.448 49.788V30.212l16.484 10.303-16.484 9.273Z"
      />
    </g>
    <defs>
      <filter
        id="a"
        width={80}
        height={81}
        x={-3.886}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.197115 0 0 0 0 0.00379068 0 0 0 0 0.119786 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_372_2492"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_372_2492"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
